"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _icon = _interopRequireDefault(require("../icon"));
var _LegendPagination = _interopRequireDefault(require("./LegendPagination.style"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var LegendPagination = function LegendPagination(_ref) {
  var nextPage = _ref.nextPage,
    previousPage = _ref.previousPage,
    id = _ref.id;
  return /*#__PURE__*/_react["default"].createElement(_LegendPagination["default"], {
    nextPage: nextPage,
    previousPage: previousPage,
    id: id
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "legend-previous-page",
    icon: "ion-chevron-left",
    id: "".concat(id, "PreviousPage"),
    size: 16,
    onClick: previousPage
  }), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "legend-next-page",
    icon: "ion-chevron-right",
    id: "".concat(id, "NextPage"),
    size: 16,
    onClick: nextPage
  }));
};
LegendPagination.defaultProps = {
  id: null
};
LegendPagination.propTypes = {
  /** trigger to go to previous page | false to disable */
  previousPage: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]).isRequired,
  /** trigger to go to next page | false to disable */
  nextPage: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]).isRequired,
  /** id of the element */
  id: _propTypes["default"].string
};
LegendPagination.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "LegendPagination",
  "props": {
    "id": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "id of the element",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "previousPage": {
      "description": "trigger to go to previous page | false to disable",
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "bool"
        }]
      },
      "required": true
    },
    "nextPage": {
      "description": "trigger to go to next page | false to disable",
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "bool"
        }]
      },
      "required": true
    }
  }
};
var _default = LegendPagination;
exports["default"] = _default;